import LinkButton from 'components/LinkButton';
import {ROUTE} from 'constants/route';
import {DateHelpers} from 'helpers/date-helpers';
import {Role} from 'helpers/user';
import React, {useMemo} from 'react';
import FeedPostContentFirmLink from 'scenes/FeedPost/components/FeedPostContent/components/FeedPostContentFirmLink';

const TypeCandidateProfileUpgrade = props => {
  const {
    user,
    post: {
      FirmName,
      FirmUrlAlias,
      FirmActive,
      currentSchoolName,
      NewsFeedDateAdd,
      Date,
    },
  } = props;

  const date = useMemo(() => {
    const [year] = DateHelpers.getDateArray(Date);
    const currentYear = DateHelpers.getCurrentYear();

    return currentYear > Number(year)
      ? DateHelpers.getMonthNameDayYearFormat(Date)
      : NewsFeedDateAdd;
  }, [Date, NewsFeedDateAdd]);

  const upgradeLink = useMemo(
    () =>
      Role.isCandidate(user) &&
      !Role.isRecruiter(user) &&
      (!Role.isCandidatePremium(user) ||
        !Role.isCandidatePremiumWithPrep(user)) ? (
        <LinkButton
          to={ROUTE.CANDIDATE_UPGRADE_PREMIUM}
          text="Premium Account"
          underline={false}
          btnFontFamily="Poppins"
        />
      ) : (
        <strong
          style={{
            fontFamily: 'Poppins',
          }}
        >
          Premium Account
        </strong>
      ),
    [user]
  );

  return (
    <div className="feed-post-content__inner feed-post-content__inner--typed">
      <div className="feed-post-content__top">
        <strong className="feed-post-content__text">GoBuyside Member</strong>
        <div className="feed-post-content__text">from</div>
        <FeedPostContentFirmLink
          isActive={FirmActive === 'Yes'}
          alias={FirmUrlAlias}
          firm={FirmName}
          school={currentSchoolName}
        />
        <div className="feed-post-content__text">upgraded to a</div>
        {upgradeLink}
      </div>
      <div className="feed-post-content__date">{date}</div>
    </div>
  );
};

export default TypeCandidateProfileUpgrade;
